import Box from '@mui/material/Box';
import React from 'react';
import { PageHeader } from './page-header';

export interface PageProps {
  title: string;
  description?: string;
  actions?: React.ReactNode;
  breadcrumbs?: { label: string; href?: string }[];
  layoutMode?: 'scrolling' | 'workspace';
  children: React.ReactNode;
  headerSx?: any;
  disableBottomPadding?: boolean;
}

export function Page({
  title,
  description,
  actions,
  breadcrumbs,
  layoutMode = 'scrolling',
  children,
  headerSx,
  disableBottomPadding = false
}: PageProps) {
  if (layoutMode === 'workspace') {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', height: 'calc(100vh - 140px)' }}>
        <PageHeader
          title={title}
          description={description}
          actions={actions}
          breadcrumbs={breadcrumbs}
          sx={headerSx}
        />
        <Box sx={{ display: 'flex', flexGrow: 1, minHeight: 0 }}>
          {children}
        </Box>
      </Box>
    );
  }

  // Scrolling layout
  return (
    <Box sx={{ pb: disableBottomPadding ? 0 : 8, display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
      <PageHeader
        title={title}
        description={description}
        actions={actions}
        breadcrumbs={breadcrumbs}
        sx={headerSx}
      />
      {children}
    </Box>
  );
}
